<template>
  <g>
    <path
      d="m11.65 44 4.65-15.2L4 20h15.2L24 4l4.8 16H44l-12.3 8.8L36.35 44 24 34.6Z"
    />
  </g>
</template>